import UserDropdownMenu from './UserDropdownMenu';
import UserDropdownMenuContainer from '../../UserMenu.container';
export default UserDropdownMenuContainer(UserDropdownMenu);
//# sourceMappingURL=index.js.map